import { NgModule } from '@angular/core';
import { MY_ACCOUNT_FEATURE_LAZY } from '@my-account/const';
import { ORDER_CORE_FEATURE } from '@order/data-access';
import { ConfigModule } from '@spartacus/core';
import { USER_PROFILE_CORE_FEATURE, UserProfileRootModule } from '@spartacus/user';

@NgModule({
  imports: [
    UserProfileRootModule,
    ConfigModule.withConfig({
      featureModules: {
        [MY_ACCOUNT_FEATURE_LAZY]: {
          module: () => import('./my-account-shell.module').then((m) => m.MyAccountShellModule),
        },
        // Спартакус использует в фасадах USER_PROFILE_CORE_FEATURE, поэтому нужно дать понять, что с нашим lazy модулем
        // Импортируется UserProfileCoreModule
        [USER_PROFILE_CORE_FEATURE]: MY_ACCOUNT_FEATURE_LAZY,
        [ORDER_CORE_FEATURE]: MY_ACCOUNT_FEATURE_LAZY,
      },
    }),
  ],
})
export class MyAccountShellEagerModule {}
